module.exports = __webpack_public_path__ + "img/spine.07471422.gif";